// @flow
import React, { Component } from 'react'
import { Link, withRouter } from "react-router-dom"
import { Menu, Icon, Tabs } from 'antd'
import { StyledMenu, StyledTab } from './style'
import { showTabs } from "../sidebar-permisson"
const Item = Menu.Item
const SubMenu = Menu.SubMenu;
type Props = {
  location: Object,
  permissions: Object
}
const TabPane = Tabs.TabPane;

class SideMenu extends Component<Props> {
  
  state = {
      isLoading: true,
      selectedKeys: [this.props.location.pathname]
  }
  
  onClick = ({item, key, keyPath}) => {
    this.setState({
      selectedKeys: keyPath,
    })
  }

  render() {

    const { permissions } = this.props
    const {selectedKeys} = this.state
    return (
        <StyledTab>
            <Tabs defaultActiveKey="1" >
                <TabPane tab="Menu" key="1" style={{textColor: "#fffff"}}>
                    <StyledMenu
                        theme='dark'
                        mode='inline'
                        onClick={this.onClick}
                        defaultSelectedKeys={['/']}
                        
                        selectedKeys={selectedKeys}>
                        { showTabs(permissions, "isDashboard") &&
                            <Item key='/'>
                                <Link to='/'>
                                    <Icon type='home'/>
                                    <span>Dashboard</span>
                                </Link>
                            </Item>
                        }
                        { showTabs(permissions, "isEarnings") &&
                            <Item key='/earnings'>
                                <Link to='/earnings'>
                                    <Icon type='line-chart'/>
                                    <span>Earnings</span>
                                </Link>
                            </Item>
                        }
                        { showTabs(permissions, "isTrades") &&
                            <SubMenu key="sub1" title={<span> <Icon type='folder-open'/><span>Trades</span></span>}>
                                <Item key='/trade-dashboard'>
                                    <Link to='/trade-dashboard'>
                                        <Icon type='home'/>
                                        <span>Dashboard</span>
                                    </Link>
                                </Item>
                                <Item key='/trades'>
                                    <Link to='/trades'>
                                        <Icon type='folder-open'/>
                                        <span>Records</span>
                                    </Link>
                                </Item>
                                <Item key='/trades-charts'>
                                    <Link to='/trades-charts'>
                                        <Icon type='line-chart'/>
                                        <span>Charts</span>
                                    </Link>
                                </Item>
                            </SubMenu>
                        }

                        { showTabs(permissions, "isCalculators") &&
                            <Item key='/calculators'>
                                <Link to='/calculators'>
                                    <Icon type='calculator'/>
                                    <span>Calculators</span>
                                </Link>
                            </Item>
                        }

                        {/*{permissions.admin &&

                        <Item key='/admin'>
                            <Link to='/admin'>
                                <Icon type='lock'/>
                                <span>Admin</span>
                            </Link>
                        </Item>
                        }*/}
                        { showTabs(permissions, "isCoaching") &&
                            <Item key='/coaching'>
                                <Link to='/coaching'>
                                    <Icon type='profile'/>
                                    <span>Coaching</span>
                                </Link>
                            </Item>
                        }
                        { showTabs(permissions, "isQuotes") &&
                            <Item key='/stocks'>
                                <Link to='/stocks'>
                                    <Icon type='profile'/>
                                    <span>Quotes</span>
                                </Link>
                            </Item>
                        }

                        { showTabs(permissions, "isTradeMatrix") &&
                            <Item key='/trade-matrix'>
                                <Link to='/trade-matrix'>
                                    <Icon type='profile'/>
                                    <span>Trade Matrix</span>
                                </Link>
                            </Item>
                        }

                        { showTabs(permissions, "isAdmin") &&
                          <SubMenu key="admin-settings" title={<span> <Icon type='lock'/><span>Admin</span></span>}>
                            <Item key='/admin/new-post'>
                              <Link to='/admin/new-post'>
                                <Icon type='home'/>
                                <span>New Post</span>
                              </Link>
                            </Item>
                            <Item key='/admin/new-trade'>
                              <Link to='/admin/new-trade'>
                                <Icon type='folder-open'/>
                                <span>New Trade</span>
                              </Link>
                            </Item>
                            <Item key='/admin/email'>
                              <Link to='/admin/email'>
                                <Icon type='line-chart'/>
                                <span>Email to Members</span>
                              </Link>
                            </Item>
                            <Item key='/admin/settings'>
                              <Link to='/admin/settings'>
                                <Icon type='line-chart'/>
                                <span>Settings</span>
                              </Link>
                            </Item>
                          </SubMenu>
                        }
                    </StyledMenu>
                </TabPane>
                <TabPane tab="Account" key="2">Account</TabPane>
            </Tabs>
        </StyledTab>
    )
  }
}

export default withRouter(SideMenu)



// WEBPACK FOOTER //
// ./src/components/list-menu/index.js